exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n  background: black;\n  color: white;\n}\n.ssk {\n  border: 2px solid #00000080;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/css-loader?{"sourceMap":false,"import":false}!/opt/build/repo/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/opt/build/repo/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles